import { defineMessages } from 'react-intl'
import ImgBlog1 from 'images/routes/landing/blogs/img-blog-1.png'
import ImgBlog2 from 'images/routes/landing/blogs/img-blog-2.png'
import ImgBlog3 from 'images/routes/landing/blogs/img-blog-3.png'

const blogMessages = [
  {
    link: 'https://blog.myfitnesspal.com/an-active-commute-could-extend-your-life/',
    image: ImgBlog1,
    text: defineMessages({
      message: {
        id: 'route.landing.blog.activecommute',
        defaultMessage: 'An Active Commute Could Extend Your Life',
      },
    }),
  },
  {
    link: 'https://blog.myfitnesspal.com/5-tips-beginning-day-hikers-2/',
    image: ImgBlog2,
    text: defineMessages({
      message: {
        id: 'route.landing.blog.5tips',
        defaultMessage: '5 Tips for Beginning Day Hikers',
      },
    }),
  },
  {
    link: 'https://blog.mapmyrun.com/secrets-of-success-how-to-turn-a-non-runner-into-a-runner/',
    image: ImgBlog3,
    text: defineMessages({
      message: {
        id: 'route.landing.blog.secretsofsuccess',
        defaultMessage: 'Secrets of Success: How to Turn a Non-Runner Into a Runner',
      },
    }),
  },
]

export default blogMessages

